import React from 'react';
import './AboutUs.css'; // We will create this CSS file later
import OurPhilosophy from '../components/AboutUsComponents/OurPhilosophy';
import FoundersNote from '../components/AboutUsComponents/FoundersNote';
import TheFounders from '../components/AboutUsComponents/TheFounders';
import Advisors from '../components/AboutUsComponents/Advisors';
import Team from '../components/AboutUsComponents/Team';
import { Helmet } from 'react-helmet-async';

function AboutUs() {
  return (
    <>
      <Helmet>
        <title>About Us - Cognitva Global Technologies Private Limited</title>
        <meta name="description" content="Learn about Cognitva Global Technologies Private Limited, our mission, vision, and the team behind our innovative solutions." />
        <meta name="keywords" content="Cognitva, About Us, Company Information, Team, Founders, Advisors" />
        <link rel="canonical" href="https://www.cognitva.ai/about-us" />
        <meta property="og:title" content="About Us - Cognitva Global Technologies Private Limited" />
        <meta property="og:description" content="Learn about Cognitva Global Technologies Private Limited, our mission, vision, and the team behind our innovative solutions." />
        <meta property="og:url" content="https://www.cognitva.ai/about-us" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="/images/cognitva-logo.png" />
      </Helmet>
      <div className="about-us-page">
        <OurPhilosophy />
        <FoundersNote />
        <TheFounders />
        <Advisors />
        <Team />
      </div>
    </>
  );
}

export default AboutUs; 